import { render, staticRenderFns } from "./ScreenEvictionsWrapper.vue?vue&type=template&id=65e04563&scoped=true&"
import script from "./ScreenEvictionsWrapper.vue?vue&type=script&lang=js&"
export * from "./ScreenEvictionsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e04563",
  null
  
)

export default component.exports